export { default as HeroElement } from './ui/hero-element/hocs';
